import {Box, Button, Drawer, Grid, useMediaQuery, useTheme} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import SideBar from "../../sidebar";
import {Outlet, useLocation} from "react-router-dom";
import * as React from "react";
import {useEffect, useState} from "react";


const SidebarLayout = () => {
    const theme = useTheme();
    const location = useLocation();
    // En móvil la barra lateral era una columna de iconos sin texto que le quitaba ~100px al
    // contenido (#13826): pasa a un botón que abre un panel con las opciones, y se cierra al navegar.
    const compact = useMediaQuery(theme.breakpoints.down("md"));
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    if (compact) {
        return (
            <Box px={1}>
                <Button startIcon={<MenuIcon/>} onClick={() => setOpen(true)} sx={{mb: 1}}>
                    Menú
                </Button>
                <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
                    <Box className="sidebar-drawer" sx={{width: 280, pt: 1}}>
                        <SideBar/>
                    </Box>
                </Drawer>
                <Box sx={{minWidth: 0}}>
                    <Outlet/>
                </Box>
            </Box>
        );
    }

    return (
        <>
            <Grid container wrap={"nowrap"}>
                <Grid item >
                    <SideBar/>
                </Grid>
                {/* minWidth:0 no es cosmético. Un flex item nace con min-width:auto, que le impone
                    como suelo el ancho mínimo de su contenido: con una tabla ancha dentro, el item
                    se planta en el ancho del viewport ENTERO y, como empieza donde acaba la barra
                    lateral, empuja esos 100px fuera de la pantalla. Medido en Vencimientos a 390px:
                    el item pedía 390 arrancando en x=100 y el documento desbordaba 99px. Con
                    minWidth:0 el item se queda en 291, cabe justo, y cada tabla scrollea dentro de
                    su propio contenedor, que es donde tiene que scrollear. */}
                <Grid item xs sx={{paddingRight: 1, minWidth: 0}}>
                    <Outlet/>
                </Grid>
            </Grid>
        </>
    );
}

export default SidebarLayout;
